import {MenuItemSpec} from "./MenuItemSpec";
import React from "react";
import {App} from "../../../app/AppSingleton";
import {ViewMode} from "../../../models/view-types";
import {Icons} from "../../../constants/icons";

export const MenuItemSwitch = (spec: MenuItemSpec): React.ReactNode => {
	const classBlock = 'dropdown';

	if (!spec.mode) return null;
	if (!spec.getCurrentMode) return null;

	const isActive = spec.getCurrentMode() === spec.mode;

	const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
	return (
		<button
			title={spec.tooltip}
			onClick={() => spec.onClick?.(spec)}
			className={`${classBlock}__item-button ${
				isActive ? `${classBlock}__item-button--active` : ''
			}`.trim()}
		>
			<div className={`${classBlock}__item-icon`}>{spec.icon}</div>
			<div className={`${classBlock}__item-button-label`}>{label}</div>
			{isActive && <div className={`${classBlock}__item-check`}>{Icons.Checked}</div>}
		</button>
	);
};